import LandUseDiagnosisV63 from './LandUseDiagnosisV63';

const readHeroScale = (): number => {
  const value = Number(
    import.meta.env.VITE_HERO_SCALE ?? '1',
  );

  if (!Number.isFinite(value)) {
    return 1;
  }

  return Math.min(1, Math.max(0.7, value));
};

/**
 * `npm run dev`ではCloudflare Pages Functionsが起動しないため、
 * ローカル画面確認時だけモック送信を使います。
 *
 * ローカルで実APIを使う場合：
 * VITE_USE_REAL_API=true npm run dev
 *
 * `npm run cf:dev`と本番ビルドでは自動的に実APIを使います。
 */
const useLocalPreviewSubmission =
  import.meta.env.DEV &&
  import.meta.env.VITE_USE_REAL_API !== 'true';

export default function App() {
  return (
    <LandUseDiagnosisV63
      submitEndpoint="/api/land-use-diagnosis"
      previewMode={useLocalPreviewSubmission}
      lineBuildUrl={import.meta.env.VITE_LINE_BUILD_URL || '#line-build'}
      lineSellUrl={import.meta.env.VITE_LINE_SELL_URL || '#line-sell'}
      lineRightsUrl={import.meta.env.VITE_LINE_RIGHTS_URL || '#line-rights'}
      heroScale={readHeroScale()}
    />
  );
}
